'use client'

import { useSession } from 'next-auth/react'
import { useCallback, useRef } from 'react'

import {
  safeLogoutRedirect,
  setLogoutPending,
} from '@maestro/commerce-blocks/utils/logout.utils'
import { createLogger } from '@maestro/core/logger'

const log = createLogger('maestro:commerce-blocks:vipps-register-modal')

export const useVippsRegisterModal = () => {
  const isSuccessRedirectRef = useRef(false)
  const { update: updateSession } = useSession()

  const handleSuccess = useCallback(() => {
    isSuccessRedirectRef.current = true
  }, [])

  const handleClose = useCallback(async () => {
    if (!isSuccessRedirectRef.current) {
      // Set flag BEFORE updateSession to prevent race condition
      // with MaestroSessionProvider detecting session change as expiry
      setLogoutPending()

      try {
        await updateSession({ trigger: 'vippsRegistrationAbandoned' })
      } catch (error) {
        log.error('[Vipps Register Modal] updateSession failed:', error)
      }

      // Use safe logout (will skip setting flag since already set)
      safeLogoutRedirect()
    }
  }, [updateSession])

  return {
    handleSuccess,
    handleClose,
    isSuccessRedirectRef,
  }
}
